<template>
  <div
    :class="[
      `flex w-full items-stretch`,
      props.variant === 'normal' &&
        `gap-1 rounded-xl border border-border bg-card p-1 dark:border-border dark:bg-card`,
      props.modes.length === 6 && `grid grid-cols-3`,
      props.modes.length === 8 && `grid grid-cols-4`,
    ]"
  >
    <label
      v-for="mode in props.modes"
      :key="mode.id"
      class="m-0 flex grow basis-0"
    >
      <input
        :id="fieldId"
        v-model="value"
        :name="fieldId"
        :value="mode.id"
        type="radio"
        class="peer size-0 border-0 opacity-0"
      />
      <span
        :class="[
          `peer flex grow items-center justify-center`,
          `outline-2 outline-offset-4 outline-blue-500 peer-focus:z-10 peer-focus-visible:outline`,
          `text-pretty text-center transition-colors`,
          props.variant === 'normal' &&
            `rounded-lg border border-transparent bg-transparent px-2 py-1 text-muted-foreground hover:bg-muted peer-checked:bg-muted peer-checked:text-foreground dark:bg-card dark:hover:bg-muted`,
          props.variant === 'dark' &&
            `rounded-md px-2 py-1 text-gray-300 hover:bg-muted peer-checked:bg-blue-500 peer-checked:text-white`,
          props.size === 'normal' && `text-sm`,
          props.size === 'small' && `text-xs`,
        ]"
      >
        {{ mode.label }}
      </span>
    </label>
  </div>
</template>

<script setup lang="ts" generic="T extends string | number">
import { useId } from "vue";

import { useSettingControl } from "../Setting/context";

export type SwitcherMode<T extends string | number> = {
  id: T;
  label: string;
};

const value = defineModel<T>({ default: "" as T });

const props = withDefaults(
  defineProps<{
    modes: SwitcherMode<T>[];
    size?: "normal" | "small";
    variant?: "normal" | "dark";
  }>(),
  {
    size: "normal",
    variant: "normal",
  }
);

const fieldId = useId();

const setting = useSettingControl();
setting?.register({ multiple: true });
</script>
